module.exports = __webpack_public_path__ + "static/media/img1-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_suelo/FE/img1-2.png
// module id = 1322
// module chunks = 3